import { render, staticRenderFns } from "./StoresDistributionCard.vue?vue&type=template&id=37b227a4&scoped=true"
import script from "./StoresDistributionCard.vue?vue&type=script&lang=js"
export * from "./StoresDistributionCard.vue?vue&type=script&lang=js"
import style0 from "./StoresDistributionCard.vue?vue&type=style&index=0&id=37b227a4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b227a4",
  null
  
)

export default component.exports